import { useState } from 'react';
import { applyPunishment } from '../../services/punishmentsService';
import './Punishmentmodal.scss';

const REASONS = [
  { value: 1, label: 'Não compareceu', icon: '🚫', description: 'O freelancer não apareceu no evento sem aviso prévio.' },
  { value: 2, label: 'Comportamento desrespeitoso', icon: '😡', description: 'Atitude inadequada com clientes, equipe ou empresa.' },
  { value: 3, label: 'Incidente grave', icon: '⛔', description: 'Situação grave que prejudicou o evento ou a empresa.' },
];

export default function PunishmentModal({
  freelancerId,
  companyId,
  freelancerName,
  jobApplicationId,
  onClose,
  onSubmitted,
}) {
  const [selectedReason, setSelectedReason] = useState(null);
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async () => {
    if (selectedReason === null) { setError('Selecione um motivo.'); return; }

    setLoading(true);
    setError('');
    try {
      await applyPunishment(freelancerId, companyId, {
        reason: selectedReason,
        description: description.trim() || null,
        jobApplicationId,
      });
      onSubmitted?.();
      onClose();
    } catch (err) {
      const msg = err?.response?.data?.message || err?.response?.data || 'Erro ao registrar punição.';
      setError(typeof msg === 'string' ? msg : 'Erro ao registrar punição.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pm-overlay" onClick={(e) => {
      if (e.target === e.currentTarget) onClose();
    }}>
      <div className="pm-modal" onClick={(e) => e.stopPropagation()}>

        <div className="pm-header">
          <h3 className="pm-title">⚠️ Relatar problema</h3>
          <p className="pm-subtitle">
            Registrar uma ocorrência com <strong>{freelancerName}</strong>.
            Ao acumular 3 advertências, o freelancer será suspenso por 7 dias.
          </p>
          <button className="pm-close" onClick={onClose}>✕</button>
        </div>

        <div className="pm-body">
          <p className="pm-label">Selecione o motivo:</p>

          <div className="pm-reasons">
            {REASONS.map((r) => (
              <button
                key={r.value}
                className={`pm-reason ${selectedReason === r.value ? 'pm-reason--active' : ''}`}
                onClick={() => setSelectedReason(r.value)}
              >
                <span className="pm-reason__icon">{r.icon}</span>
                <div>
                  <p className="pm-reason__label">{r.label}</p>
                  <p className="pm-reason__desc">{r.description}</p>
                </div>
              </button>
            ))}
          </div>

          <div className="pm-field">
            <label className="pm-label">Detalhes adicionais <span>(opcional)</span></label>
            <textarea
              className="pm-textarea"
              placeholder="Descreva o ocorrido com mais detalhes..."
              value={description}
              onChange={(e) => setDescription(e.target.value.substring(0, 500))}
              rows={3}
              maxLength={500}
              disabled={loading}
            />
            <span className="pm-counter">{description.length}/500</span>
          </div>

          <div className="pm-warning">
            ℹ️ Esta ação será notificada ao freelancer. Punições indevidas podem ser contestadas.
          </div>

          {error && <p className="pm-error">{error}</p>}
        </div>

        <div className="pm-footer">
          <button className="pm-btn pm-btn--cancel" onClick={onClose} disabled={loading}>
            Cancelar
          </button>
          <button
            className="pm-btn pm-btn--submit"
            onClick={handleSubmit}
            disabled={loading || selectedReason === null}
          >
            {loading ? 'Registrando...' : 'Confirmar ocorrência'}
          </button>
        </div>

      </div>
    </div>
  );
}